<section *ngIf="userId; else invalidUser">
    <h1
      class="mb-4 -mt-3 text-2xl font-extrabold leading-snug tracking-tight text-left md:text-4xl onboarding-heading"
    >
      Complete your account setup
    </h1>
    <nz-alert
      [nzDescription]="'Please setup a password for your account on BusPro'"
      [nzMessage]="'Hello ' + (name || 'there')"
    ></nz-alert>

    <form
      #accountForm
      (ngSubmit)="completeAccountSetup()"
      [formGroup]="form"
      class="mt-8 space-y-4"
      novalidate
    >
      <label class="block">
        <span class="block mb-1 text-sm font-medium onboarding-label"
          >Your Account Email is</span
        >
        <input
          class="form-input input input-bordered input-md rounded-lg w-full"
          autocomplete="username"
          formControlName="email"
          inputmode="email"
          name="email"
          placeholder="Ex. james@bond.com"
          required
          type="email"
        />
      </label>
      <label class="block">
        <span class="block mb-1 text-sm font-medium onboarding-label"
          >Your Password</span
        >
        <div class="relative">
          <input
            class="form-input input input-md input-bordered rounded-lg w-full pr-24"
            autocomplete="new-password"
            formControlName="password"
            name="password"
            [type]="isPasswordVisible() ? 'text' : 'password'"
            placeholder=""
            required
            aria-label="Password"
          />
          <button
            type="button"
            tabindex="-1"
            class="btn btn-ghost btn-xs absolute right-2 top-1/2 -translate-y-1/2"
            (click)="isPasswordVisible.set(!isPasswordVisible())"
            aria-label="Toggle password visibility"
          >
            {{ isPasswordVisible() ? 'Hide' : 'Show' }}
          </button>
        </div>
      </label>
      <label class="block">
        <span class="block mb-1 text-sm font-medium onboarding-label"
          >Confirm Password</span
        >
        <div class="relative">
          <input
            class="form-input input input-md input-bordered rounded-lg w-full pr-24"
            autocomplete="new-password"
            formControlName="passwordConfirm"
            name="passwordConfirm"
            [type]="isPasswordConfirmVisible() ? 'text' : 'password'"
            placeholder=""
            required
            aria-label="Confirm Password"
          />
          <button
            type="button"
            tabindex="-1"
            class="btn btn-ghost btn-xs absolute right-2 top-1/2 -translate-y-1/2"
            (click)="isPasswordConfirmVisible.set(!isPasswordConfirmVisible())"
            aria-label="Toggle confirm password visibility"
          >
            {{ isPasswordConfirmVisible() ? 'Hide' : 'Show' }}
          </button>
        </div>
      </label>
      <div>
        <button
          [disabled]="isSubmitting()"
          class="w-full mt-8 btn btn-primary btn-lg"
          type="submit"
          value="Register"
          aria-busy="isSubmitting()"
        >
          {{ isSubmitting() ? 'Submitting…' : 'Complete Account' }}
        </button>
      </div>
    </form>
    <div class="pt-6 mt-6 text-sm font-medium border-t onboarding-footer">
      Already have an account?
      <a class="onboarding-link" routerLink="/passport/login">Login</a>
    </div>
</section>

<ng-template #invalidUser>
  <div class="py-12 text-center">
    <p class="onboarding-muted mb-4">
      Invalid or missing user. Please use the link from your invitation email.
    </p>
    <a routerLink="/passport/login" class="btn btn-primary">Go to Login</a>
  </div>
</ng-template>
